/* eslint-disable no-unused-vars */
import selectAgency from './select_agency';
import messageApp from './message_app';

export default function u() {
  return (
    <>
      <selectAgency />
      <messageApp />
    </>
  );
}
